__turbopack_context__.v({
  "onlyDesktopContent": "_1C2iBG_onlyDesktopContent",
  "tabletContent": "_1C2iBG_tabletContent",
});
